import { render, staticRenderFns } from "./chooseMortgage.vue?vue&type=template&id=755c6912&"
import script from "./chooseMortgage.vue?vue&type=script&lang=js&"
export * from "./chooseMortgage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports